'use strict';

(function() {
	angular.module('onboarding.common.settings')
		.directive('cobCarrierProfileSettings', cobCarrierProfileSettings);

	cobCarrierProfileSettings.$inject = [
		'subjectObserverMessagesService', 'observerService', 'carrierSettingsService', 'sessionService',
		'authenticationService', '$state', 'validationService', '$stateParams', '$window', '$sce'
	];

	var subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		carrierSettingsService,
		sessionService,
		authenticationService,
		validationService,
		state,
		$stateParams,
		$window,
		$sce;

	function cobCarrierProfileSettings(_subjectObserverMessagesService_,
		_observerService_,
		_carrierSettingsService_,
		_sessionService_,
		_authenticationService_,
		$state,
		_validationService_,
		_$stateParams_,
		_$window_,
		_$sce_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierSettingsService = _carrierSettingsService_;
		sessionService = _sessionService_;
		authenticationService = _authenticationService_;
		validationService = _validationService_;
		state = $state;
		$stateParams = _$stateParams_;
		$window = _$window_;
		$sce = _$sce_;

		return {
			scope: {},
			templateUrl: '/app/common/settings/cobCarrierProfileSettings.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.carrierId = $stateParams.carrierId;

			scope.m = {};
			scope.showEmailIsNotValid = false;
			scope.isDirty = false;
			scope.closeModal = closeModal;
			scope.onProfileOpen = onProfileOpen;
			scope.isInternalAdmin = isInternalAdmin;
			scope.editEmail = editEmail;
			scope.discardEdit = discardEdit;
			scope.save = save;
			scope.validateEmail = validateEmail;
			scope.setIsDirty = setIsDirty;
			scope.logout = logout;
			scope.saveEmailEdit = saveEmailEdit;
			scope.modalClick = modalClick;

			//320 view
			scope.showMobileUniNav = showMobileUniNav;
			scope.toggleCarrierProfiledropDown = toggleCarrierProfiledropDown;
			scope.toggleCarrierHelpDropDown = toggleCarrierHelpDropDown;
			scope.closeMobileConfirmation = closeMobileConfirmation;
			scope.openLiveChat = openLiveChat;
			scope.m.mobileConfirmation = '';
			scope.m.displayMobileConfirmation = false;
			scope.m.displayMobileProfile = false;
			scope.m.displayMobileHelp = false;
			scope.m.truckersEdgeUrl = null;
			scope.m.CarrierMobileEmailView = false;
			scope.m.slideRight = false;
			scope.m.slideUp = false;

			registerEventHandlers();
			loadData();
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_PROFILE_CARRIER_OPEN, handler: onProfileOpen },
					{ message: observerMessages.COB_OBSERVER_PROFILE_SETTINGS_DIRTY, handler: onDirty }
				]);
		}

		function loadData() {
			if (scope.carrierId) {
				carrierSettingsService.lookupCarrierProfileModal(scope.carrierId)
					.then(function(response) {
						scope.m.carrierName = response.data.userName;
						scope.m.dotNumber = response.data.dotNumber;
						scope.m.datNumber = response.data.datNumber;
						scope.m.intrastateNumber = response.data.intrastateNumber;
						scope.m.carrierEmail = response.data.email;
						scope.emailClean = scope.m.carrierEmail;
						if (response.data.dbaName) {
							scope.m.carrierCompanyName = response.data.dbaName;
						} else {
							scope.m.carrierCompanyName = response.data.legalName;
						}

						discardEdit(true);
					});
			}
		}

		function isInternalAdmin() {
			return sessionService.isAuthorizedInternalAdmin();
		}

		function onProfileOpen(data) {
			scope.isVisible = true;
			scope.m.slideRight = true;
			scope.m.truckersEdgeUrl = data;
		}

		function closeModal() {
			if (scope.isDirty) {
				scope.errorMessage = 'Save or discard your changes';
				scope.errorMessageClass = 'has-message--error';
			} else {
				scope.isVisible = false;
				discardEdit();
				scope.m.slideRight = false;
				scope.m.displayMobileProfile = false;
				scope.m.displayMobileHelp = false;
				scope.m.CarrierMobileEmailView = false;
			}
		}

		function editEmail() {
			scope.m.editEmail = true;
			scope.m.displayMobileProfile = false;
			scope.m.CarrierMobileEmailView = true;
			scope.m.slideRight = false;

		}

		function discardEdit(keepMessage) {
			if (scope.m.editEmail)
				discardEmailEdit();

			if (!keepMessage) {
				scope.errorMessage = '';
				scope.errorMessageClass = '';
			}

			scope.isDirty = false;
		}

		function discardEmailEdit() {
			scope.m.editEmail = false;
			scope.m.carrierEmail = scope.emailClean;
			scope.m.emailValidationMessage = '';
		}

		function validateEmail() {
			if (scope.m.carrierEmail &&
                validationService.isValidEmail(scope.m.carrierEmail)) {
				scope.m.emailValidationMessage = '';

				return true;
			} else {
				scope.m.emailValidationMessage = 'Please enter a valid email.';

				return false;
			}
		}

		function save() {
			if (scope.m.editEmail) {
				saveEmailEdit();
			}
		}

		function saveEmailEdit() {
			if (validateEmail()) {
				carrierSettingsService.updateCarrierEmail(scope.m.carrierEmail, scope.carrierId)
					.then(function(response) {
						if (response.data.isSuccess) {
							if (response.data.message) {
								scope.m
									.emailValidationMessage =
                                    'The email address entered is already associated with an existing DAT OnBoard account. Please enter a different email address to proceed.';

								return;
							}
							scope.errorMessage = 'Email changes saved';
							scope.errorMessageClass = 'has-message--confirm';
							loadData();
							scope.m.displayMobileConfirmation = true;
							scope.m.mobileConfirmation = 'Username/Email Change Complete';
						}
					});
			}
		}

		function onDirty() {
			scope.isDirty = true;
		}

		function setIsDirty() {
			scope.isDirty = true;
		}

		function modalClick() {
			if (scope.errorMessage) {
				scope.errorMessage = '';
				scope.errorMessageClass = '';
			}
		}

		//320 view

		function showMobileUniNav() {
			scope.mobileUniNavDisplay = true;
		}

		function toggleCarrierProfiledropDown() {
			if (!scope.m.displayMobileProfile) {
				scope.m.displayMobileProfile = true;
				scope.m.displayMobileHelp = false;
			} else {
				scope.m.displayMobileProfile = false;
			}
		}

		function toggleCarrierHelpDropDown() {
			if (!scope.m.displayMobileHelp) {
				scope.m.displayMobileHelp = true;
				scope.m.displayMobileProfile = false;
			} else {
				scope.m.displayMobileHelp = false;
			}
		}

		function closeMobileConfirmation() {
			scope.m.displayMobileConfirmation = false;
			scope.closeModal();
		}

		function logout() {
			sessionService.destroy();
			authenticationService.logout();
		}

		function openLiveChat() {
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_LOAD_CHATSUPPORT);
		}
	}
})();
